<div class="page-layout blank fullwidth p-12"  style="height: 1px; overflow-y: scroll; padding: 0 !important;   top: 1px;z-index: 9;">
<div class="container">
  
   
    <!-- <div class="status" [ngClass]="{
      'requested': status === 'Requested',
      'quote-received': status === 'Quote Received',
      'quote-approved': status === 'Quote Approved'

      'order-created': filteredOrderList.length > 0,
      'quote-approved': quotationapproved.length > 0 && filteredOrderList.length === 0,
      'quote-received': quotationreceived.length > 0 && quotationapproved.length === 0 && filteredOrderList.length === 0,
      'requested': quotationreceived.length === 0 && quotationapproved.length === 0 && filteredOrderList.length === 0 
    }">
      {{getStatus()}}
    </div> -->

  <!-- <div class="details" *ngIf="isOpen">
    <div class="logo-and-model">
      <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
      <div class="model-info">
        <span class="model-name">{{requestDetails?.spareRequest?.make}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.model}}, {{requestDetails?.spareRequest?.fuelType}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.registrationNumber}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.vinNumber}}</span>
      </div>
    </div>
    <div class="timestamp">{{requestDetails?.spareRequest?.created | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}
      <button type="button" class="QuoteBtn"  (click)="openSidebarQuote()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length>=0 || quotationapproved.length>0)" >Create Customer Quote</button>
         </div>
    
  </div> -->

  
  <div class="card-container">
  <div class="header">
    <div class="car-info">
      <mat-icon (click)="goBack()" >keyboard_arrow_left</mat-icon>
      <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
      <div>
        <span class="car-name">{{requestDetails?.spareRequest?.model}}</span>
        <span class="car-number">{{requestDetails?.spareRequest?.registrationNumber}}</span>
      </div>
    </div>
    <div>
      <div class="quote-status">
        <div *ngIf="magicQuote==1" style="width: 12%;" class="magic-div"><img class="magic" src="../../../../assets/images/order-details/magic.jpg"></div>

          <div class="status" [ngClass]="{
        'requested': getStatus() === '⏳ Requested',
        'quote-received': getStatus() === '💬 Quote Received',
        'quote-approved': getStatus() === '✅ Quote Approved',
        'order-created': getStatus() === '📦 Order Created',
        'cancelled': getStatus() === '❌ Cancelled'
      }">
        {{getStatus()}}
      </div>
          <button mat-icon-button (click)="toggle()" style="background: linear-gradient(45deg, #F8FAFC, #FFFFFF);border-radius: 11px;margin: 0px;margin-left: 8px;" class="mat-focus-indicator mat-icon-button mat-button-base">
        <mat-icon [ngClass]="{ 'rotated': isOpen }" class="expand_more">expand_more</mat-icon>
      </button>
      </div>
      <button type="button" class="QuoteBtn"  (click)="openSidebarQuote()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length>=0 || quotationapproved.length>0)" >Create Customer Quote</button>
    </div>
  </div>

 <div class="details-grid" *ngIf="isOpen">
  <div class="detail-box">
    <label>VARIANT</label>
    <span>{{requestDetails?.spareRequest?.variant}}</span>
  </div>
  <div class="detail-box">
    <label>REQUEST ID</label>
    <span class="link">#{{requestDetails?.spareRequest?.id}}</span>
  </div>
  <div class="detail-box">
    <label>FUEL & MODEL YEAR</label>
    <span>{{requestDetails?.spareRequest?.fuelType}}, {{requestDetails?.spareRequest?.manufacturingYear}}</span>
  </div>
  <div class="detail-box">
    <label>REQUESTED DATE & TIME</label>
    <span>{{requestDetails?.spareRequest?.created | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}</span>
  </div>

  <!-- Insurance Details -->
  <div class="detail-box full-width" style="background-color: #D7F5FC8C; padding: 10px; border-radius: 6px;" *ngIf="requestDetails?.spareRequest?.claimNo || claimType">
    <h4 class="head-name">🛡️ Insurance Details</h4>
    <div class="insurance">
    <div class="sub-detail">
      <label>Claim Number</label>
      <span>{{requestDetails?.spareRequest?.claimNo}}</span>
    </div>
    <div class="sub-detail">
      <label>Claim Type</label>
      <span>{{requestDetails?.spareRequest?.claimType}}</span>
    </div>
    </div>
  </div>

  <!-- Surveyor Contact -->
  <div class="detail-box full-width" style="background-color: #fff9e6; padding: 10px; border-radius: 6px;" *ngIf="requestDetails?.spareRequest?.surveyor || surveyorContact">
    <h4 class="head-name">🧑‍💼 Surveyor Contact</h4>
    <div class="insurance">
    <div class="sub-detail">
      <label>Surveyor Name</label>
      <span>{{requestDetails?.spareRequest?.surveyor}}</span>
    </div>
    <div class="sub-detail">
      <label>Mobile Number</label>
      <span>📞 {{requestDetails?.spareRequest?.surveyorContact}}</span>
    </div>
    </div>
  </div>
</div>


</div>


  <!-- tabs -->
  <div class="buttons" *ngIf="isRequestDetails">
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'requests'}"
            (click)="setActiveTab('requests')">REQUESTS ({{requestDetails?.spareRequestItemList?.length}}  {{ requestDetails?.spareRequestItemList?.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-received'}"
            (click)="setActiveTab('quote-received')">QUOTE RECEIVED ({{quotationreceived.length}}  {{ quotationreceived.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-approved'}"
            (click)="setActiveTab('quote-approved')">QUOTE APPROVED ({{quotationapproved.length}}  {{ quotationapproved.length === 1 ? 'item' : 'items' }})</button>
    <button class="request-button" 
            *ngIf="filteredOrderList?.length>0"
            [ngClass]="{'active': activeTab === 'order-created'}"
            (click)="setActiveTab('order-created')">ORDER CREATED ({{requestDetails?.orderCreatedItems}}  {{ requestDetails?.orderCreatedItems === 1 ? 'item' : 'items' }})</button>
  </div>


  <!-- Request received items -->
    <div class="overlays" [class.visible]="openEditIndex" (click)="toggleEditMenu($event)"></div>
  <div *ngIf="isRequestDetails && activeTab === 'requests'" class="request-item">
    <div style="display: flex;justify-content: space-between;">
      <div class="request-info">Request made for {{requestDetails?.spareRequestItemList?.length}} items <button (click)="shareMagicQuoteOnWhatsapp()"><i>share</i>Share Request</button></div>
      <div class="menu-container"  *ngIf="getStatus()=='✅ Quote Approved' || getStatus() === '💬 Quote Received' || getStatus() === '⏳ Requested' || getStatus() === '📦 Order Created'">
        <p class="dots" (click)="toggleEditMenu($event)">⋯</p>
      </div>
      <div *ngIf="openEditIndex"
          class="edit-menu">

        <p (click)="addMoreItems(requestDetails?.spareRequest)"  style="padding-right: 13px;"><img src="../../../../assets/images/add-more.png" style="width: 14%;"> Add More Items</p>
        <p (click)="editRequest(requestDetails?.spareRequest?.id)" *ngIf="insurance?.length>=1">📝 Edit Request Type</p>
         <!-- New Option - Add Back -->
        <p *ngIf="canEditItems()" (click)="editItem(requestDetails?.spareRequestItemList)">✏️ Edit Request </p>
        <!-- New Option - Remove -->
        <p *ngIf="canDeleteItems() && !hasCreatedItem()"  (click)="openRequestCancelPopup()">  🗑️ Cancel Request </p>
      </div>
    </div>
    <div class="item-card" *ngFor="let item of requestDetails?.spareRequestItemList">
          <div class="item-header">
            <div class="item-left">
              <p>⚙️</p>
              <div class="item-details">
                <span class="typed-text" *ngIf="!(item.itemDescription==item.itemName)">{{item.itemDescription}}</span>
                <div class="corrected-row">
                  <span class="arrow" *ngIf="!(item.itemDescription==item.itemName)">→
                  <span class="corrected-text">{{item.itemName}}</span>
                </span>
                  <span class="corrected-text" *ngIf="(item.itemDescription==item.itemName)">{{item.itemName}}</span>
                  <span class="tag auto-corrected" *ngIf="!(item.itemDescription==item.itemName)"> ✅ Auto-corrected</span>
                  <span class="tag as-typed" *ngIf="item.itemDescription==item.itemName">⚠️ As Typed</span>
                </div>
                <span class="qty">Qty: {{item.itemQuantity}} Unit</span>
              </div>
            </div>
            <div class="status requested"  *ngIf="item.status==1 || item.status==2 || item.status==3">⏳ Requested</div>
            <div class="status cancelled"  *ngIf="item.status==0">❌ Cancelled</div>
            <div class="status quote-received"  *ngIf="item.status==8">💬 Quote Received</div>
            <div class="status quote-approved"  *ngIf="item.status==9">✅ Quote Approved</div>
            <div class="status order-created"  *ngIf="item.status==4 || item.status==10">📦 Order Created</div>
          </div>
    </div>
    <div class="photo-sec">
      <div class="add-image-card" *ngIf="imagePreviews.length<= 0">

        <div class="header-img">
          <span class="material-icons camera-icon">photo_camera</span>
          <span class="title">Add images (optional)</span>
        </div>

        <p class="subtitle">
          Not sure about the part? A photo helps our team quote faster.
        </p>

        <input
          type="file"
          id="imageUpload"
          hidden
          multiple
          accept="image/*"
          (change)="onFileSelected($event)"
        />

        <label class="upload-box" for="imageUpload">

          <div class="camera-circle">
            <span class="material-icons">photo_camera</span>
          </div>

          <div class="upload-title">Upload part photos</div>
          <div class="upload-subtitle">You can add multiple images</div>

        </label>


      </div>
      <div class="photo-card" *ngIf="imagePreviews.length >0">

        <div class="header-img">
          <span class="material-icons camera-icon">photo_camera</span>
          <div>
            <div class="title">
              Add images (optional)
            </div>
            <div class="subtitle">
                Not sure about the part? A photo helps our team quote faster.
            </div>
          </div>
        </div>
        <div class="image-added">
          <p>Added photos ({{imagePreviews.length}})</p>
          <label for="imageUpload" class="add-more-img">
            <span >+ Add more images</span>
          </label>
        </div>

        <input
          type="file"
          id="imageUpload"
          hidden
          multiple
          accept="image/*"
          (change)="onFileSelected($event)"
        />

        <div class="image-row">

          <div
            class="image-box"
            *ngFor="let img of imagePreviews; let i = index"
          >
            <img [src]="img.url" (click)="openImagePreview(img.url)" />

            <span
              class="material-icons remove-icon"
              (click)="removeImage(i)"
            >
              close
            </span>
          </div>

          <label for="imageUpload" class="image-box add-box">
            <span class="material-icons">add</span>
          </label>

        </div>

        <div class="info-box">
          <span class="material-icons info-icon">info</span>
          <span>
            This helps our team suggest the correct parts and speeds up your quote.
          </span>
        </div>

      </div>
      
      <!-- IMAGE POPUP -->
        <div
          class="overlay-img-preview"
          [class.visible]="imagePreviewOpen"
          (click)="closeImagePreview()"
        ></div>
        <div class="image-preview-modal" [class.open]="imagePreviewOpen">
          <span class="material-icons close-btn-preview-modal" (click)="closeImagePreview()">close</span>
          <img [src]="previewImageUrl" />
        </div>
    </div>
  </div>

  <!-- <div *ngIf="isRequestDetails && activeTab === 'requests'" class="request-item">
    <div class="request-info">Request made for {{notes?.length}} items </div>
    <div class="item" *ngFor="let item of notes">
      <span class="span-item-name">{{item}}</span>
      <span class="quantity">1 Unit</span>
    </div>
  </div> -->
  <!-- End Request received items -->

  <!-- Quotation Received -->
  <div *ngIf="activeTab === 'quote-received'">
    <div *ngIf="quotationreceived.length > 0 else noQuotesReceived" >
      <div style="display: flex;justify-content: space-between;margin-top: 10px;">
      <div class="request-info">Quote received for {{quotationreceived.length}} items <button (click)="shareQuoteReceivedViaWhatsApp()"><i>share</i>Share for Approval</button></div>
            <div class="menu-container"  *ngIf="getStatus()=='✅ Quote Approved' || getStatus() === '💬 Quote Received' || getStatus() === '⏳ Requested' || getStatus() === '📦 Order Created'">
        <p class="dots" (click)="toggleEditMenu($event)">⋯</p>
      </div>
      <div *ngIf="openEditIndex"
          class="edit-menu">

        <p (click)="addMoreItems(requestDetails?.spareRequest)"><img src="../../../../assets/images/add-more.png" style="width: 14%;"> Add More Items</p>
        <p (click)="editRequest(requestDetails?.spareRequest?.id)"  *ngIf="insurance?.length>=1">📝 Edit Request Type</p>
         <!-- New Option - Add Back -->
        <p *ngIf="canEditItems()" (click)="editItem(requestDetails?.spareRequestItemList)">✏️ Edit Request </p>
        <!-- New Option - Remove -->
        <p *ngIf="canDeleteItems() && !hasCreatedItem()"  (click)="openRequestCancelPopup()">  🗑️ Cancel Request </p>

      </div>
      </div>
      <div  class="items" style="    background: linear-gradient(45deg, #b6f1ff8c, #FFFFFF); margin-bottom: 78px;">
        <!-- <div>
            <div class="request-info">Quote received for {{quotationreceived.length}} items </div>
            <div class="item" >
              <div class="checkboxselect">
                <label class="custom-checkbox">
                  <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                  <span class="checkmark"></span>
                </label>
                
                <div class="select-parts">
                <span >Select All Items</span>
                <p>Choose all parts for approval</p>
                </div>
              </div>
              <div class="select-parts" style="text-align: end;">
                <span class="quote-rcvd-prz">₹ {{quoteReceivedPrice | number:'1.2-2'}}</span>
                <p class="total-slng-prz"> Total MRP Price  </p>
              </div>
            </div>
            <div class="quotereceived-items" *ngFor="let item of quotationreceived" [ngClass]="{'border-box': item.selected}">
              <div style="display: flex;">
                <div class="lines" style="display: flex;">
                <label class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="item.selected" (change)="toggleItemSelection()" />
                  <span class="checkmark"></span>
                </label>

                  
                <div style="width: 60%;margin-left: 12px;">
                  <span class="part-name" >{{item.itemName}}</span>
                  <p class="item-brand">{{item.brand}}</p>
                  <p class="item-brand">{{item.itemQuantity}} Unit</p>
                </div>
                </div>
                <div class="lines" style="text-align: end;">
                
                  <p class="item-brand">Total MRP</p>
                  <span class="date">₹{{(item.mrp * item.itemQuantity) | number:'1.2-2'}}</span>
                  <span class="availablity" *ngIf="!isMobile">
                  ✅ {{ transform(item.edt) }}
                  </span>
                </div>
                </div>
                
                <div *ngIf="isMobile" style="text-align: end;margin-top: -23px;">
                <span class="availablity" *ngIf="isMobile">
                  ✅ {{ transform(item.edt)   }}
                  </span>
                  </div>
            </div>
          </div> -->
        <div class="header-box">
          <div class="approve-heading">
          <h2>Approve Your Quote – Fast, Clear & Cost-Smart</h2>
          <p>Compare OEM vs OES options, select only what you want, and approve confidently.</p>
          
          <div class="action-buttons">
            <button (click)="setAll('OES');  selectedPreview = 'OES'" [ngClass]="{ primary1: selectedPreview === 'OES'}">🟢 All OES</button>
            <button (click)="setAll('OEM');  selectedPreview = 'OEM'" [ngClass]="{ primary1: selectedPreview === 'OEM'}">🔵 All OEM</button>
            <!-- <button class="reset-btn" (click)="resetRecommendation()"><span style="color: green;">♻</span> Reset Recommendation</button> -->
          </div>
          </div>
          <div class="aprove-help">
        <!-- <button class="help-btn">📞 Need help?</button> -->
          

          <button
            class="approve-main-btn"
            [disabled]="selectedParts.length === 0"
            (click)="approveQuote()"
            *ngIf="selectedParts.length > 0"
          >
            {{ approveLabel }}
          </button>
          </div>
        </div>
        <div class="layout">
          <!-- LEFT SIDE — PARTS LIST -->
          <div class="parts-list">
            <div class="column-header">
              <div class="col-select">SELECT</div>
              <div class="col-details">PART DETAILS</div>
              <div class="col-qty">QTY</div>
              <div class="col-option">OPTION</div>
              <div class="col-availability">AVAILABILITY</div>
              <div class="col-price">PRICE</div>
            </div>
            <div *ngFor="let p of parts" [ngClass]="{'approved-background': p.isApproved}" class="parent-part-row-status">
              <div class="part-row-status">
                <div class="status requested" *ngIf="p.status==1 || p.status==2 || p.status==3">⏳ Requested</div>
                <div class="status cancelled" *ngIf="p.status==0">❌ Cancelled</div>
                <div class="status quote-received" *ngIf="p.status==8">💬 Quote Received</div>
                <div class="status quote-approved" *ngIf="p.status==9">✅ Quote Approved</div>
                <div class="status order-created" *ngIf="p.status==4 || p.status==10">📦 Order Created</div>
              </div>
              <div class="parent-part-row">
                <div class="part-row">
                  <div class="left-section">
                    <label class="custom-checkbox" *ngIf="!p.isApproved">
                        <input type="checkbox" [(ngModel)]="p.selected">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div>
                      <div class="title">{{ p.title }}</div>
                      <div class="meta" *ngIf="p.option === 'OEM'">{{ p.oem.brand }}</div>
                      <div class="meta" *ngIf="p.option === 'OES'">{{ p.oes.brand }}</div>
                      
                    <!-- <div *ngIf="p.option === 'OES' && (p.priceOEM > p.priceOES) &&  p.oem" class="savings">
                      🎉 You're saving ₹{{ (p.priceOEM - p.priceOES)  | number:'1.2-2' }} vs OEM.
                    </div> -->
                    
                    <div *ngIf="p.option === 'OEM' && (p.priceOEM > p.priceOES) && p.oes" class="note">
                      💡 Save ₹{{ (p.priceOEM - p.priceOES)  | number:'1.2-2'}} with OES – same performance.
                    </div>
                    </div>

                  <p class="qty-sec">{{p.qty}}</p>

                  <div class="option-switch">
                    <button
                      [class.active]="p.option === 'OEM'"
                      [disabled]="!p.oem"
                      (click)="setOption(p, 'OEM')"
                    >
                      OEM
                    </button>
                    <button
                      [class.active]="p.option === 'OES'"
                      [disabled]="!p.oes"
                      (click)="setOption(p, 'OES')"
                    >
                      OES
                    </button>
                  </div>
                  <div class="availability-wrapper" *ngIf="p.option === 'OES'">
                    <span class="availablity"   [ngClass]="getAvailabilityClass(transform(p.oes.edt))">  {{ getAvailabilityIcon(transform(p.oes.edt)) }}   {{ transform(p.oes.edt) }}</span>   
                    <div class="availability-subtext"  [ngClass]="getAvailabilityClass(transform(p.oes.edt))">  {{ getAvailabilityText(transform(p.oes.edt)) }}</div>   
                  </div>
                  <div class="availability-wrapper" *ngIf="p.option === 'OEM'">
                    <span class="availablity"   [ngClass]="getAvailabilityClass(transform(p.oem.edt))">  {{ getAvailabilityIcon(transform(p.oem.edt)) }}   {{ transform(p.oem.edt) }}</span>
                    <div class="availability-subtext"  [ngClass]="getAvailabilityClass(transform(p.oem.edt))">  {{ getAvailabilityText(transform(p.oem.edt)) }} </div>
                  </div>
                  <div class="price-block">
                    <div class="price-label">SELLING PRICE</div>
                    <div class="price"> ₹{{ getSelectedPrice(p)  | number:'1.2-2' }} </div>
                    <div class="mrp-text" *ngIf="p.option === 'OES' && p.oes?.mrp">  MRP:
                        <span class="mrp-value">
                          ₹{{ p.oes.mrp | number:'1.2-2' }}
                        </span>
                    </div>
                    <div class="mrp-text" *ngIf="p.option === 'OEM' && p.oem?.mrp">
                      MRP:
                      <span class="mrp-value">
                        ₹{{ p.oem.mrp | number:'1.2-2' }}
                      </span>
                    </div>
                    <div *ngIf="p.option === 'OES' &&  p.oem" style="color: #94A3B8;" >
                      OEM: ₹{{ p.priceOEM  | number:'1.2-2' }}
                    </div>
                    <div *ngIf="p.option === 'OEM' &&  p.oes" style="color: #94A3B8;">
                      OES: ₹{{ p.priceOES  | number:'1.2-2' }}
                    </div>
                    <div class="tax-text">  Inclusive of taxes</div>
                  </div>
                </div>
                <!-- OES Recommendation Fixed Bar -->
                <!-- <div class="avx-oes-fixed-recommendation-bar"  *ngIf=" activeTab === 'quote-received' && quotationreceived.length > 0 && p.option === 'OES'&& p.oem && p.oes && ( (p.oem.sellingPrice > p.oes.sellingPrice) || (p.allOes && p.allOes.length > 1) ) "> -->
                <div class="avx-oes-fixed-recommendation-bar" *ngIf="activeTab === 'quote-received' && quotationreceived.length > 0  && p.option === 'OES'&& ((p.oem && p.oes && p.oem.sellingPrice > p.oes.sellingPrice) || (p.allOes?.length > 1))">
                  <div class="avx-oes-fixed-left">
                    <div class="avx-oes-fixed-icon">💰</div>
                    <div class="avx-oes-fixed-content" *ngIf="p.oem && p.oes && (p.oem.sellingPrice > p.oes.sellingPrice)">
                      <p class="avx-oes-fixed-title"> You save  ₹{{ (p.oem.sellingPrice - p.oes.sellingPrice)  | number:'1.2-2' }} vs OEM </p>
                      <span class="avx-oes-fixed-subtitle">Great savings on this order</span>
                    </div>
                  </div>
                  <button class="avx-oes-fixed-btn"  *ngIf="p.allOes && p.allOes.length > 1" [disabled]="p.isApproved" (click)="!p.isApproved && openMultipleOesSidebar(p)"> View More OES Options</button>
                </div>
              </div>
            </div>
          </div>

          <!-- RIGHT SIDE — QUOTE SUMMARY -->
          <div class="summary-box" *ngIf="selectedParts.length > 0">
            <h3>Quote Summary</h3>
            <p>{{selectedParts.length}} items selected</p>

            <div *ngFor="let p of selectedParts" class="summary-item">
              <div>
                <div class="summary-title">{{ p.title }}</div>
                <div class="summary-qty">Qty: {{ p.qty }} • {{ p.option }}</div>
              </div>
              <div class="summary-title">₹{{ (getSelectedPrice(p) * p.qty)  | number:'1.2-2' }}</div>
            </div>

            <div *ngIf="oesSavings>0" class="green-tip">
              <strong>🎉 Great choice! You save {{oesSavings | number:'1.2-2' }} by picking OES </strong><br />
              Smart pick — same fit, trusted quality
            </div>

            <!-- <div class="summary-total-row">
              <span>Subtotal</span>
              <span>₹{{ subtotal  | number:'1.2-2'}}</span>
            </div> -->

            <!-- <div class="summary-total-row">
              <span>GST (18%)</span>
              <span>₹{{ gst | number }}</span>
            </div>

            <div class="summary-total-row">
              <span>Delivery</span>
              <span>₹{{ delivery }}</span>
            </div> -->

            <hr />

            <div class="final-total">
              <span>Total Amount</span>
              <span>₹{{ total | number:'1.2-2' }}</span>
            </div>

            <button
              class="approve-summary-btn"
              [disabled]="selectedParts.length === 0"
              (click)="approveQuote()"
            >
              {{ approveLabel }}
            </button>

            <div class="bottom-actions">
              <!-- <button class="pdf-btn" (click)="close()">📎 Download PDF</button> -->
              <button class="whatsapp-btn" (click)="shareRequestViaWhatsApp()">📲 Share WhatsApp</button>
            </div>

            <div class="foot-note">
              <p>✅ Quality guaranteed parts </p>
              <p>⭐ Best market prices </p>
              <p>⏰ Same day delivery available </p>
              <small>Prices valid for 24 hours</small>
            </div>
              <div class="overlay" (click)="close()"></div>

        <div class="popup" *ngIf="openPopup">
          <div class="header">
            <span>Export Quote</span>
            <button class="close-btn" (click)="close()">✕</button>
          </div>

          <button class="btn blue" (click)="downloadOES()">Download OES Quote PDF</button>
          <button class="btn white" (click)="downloadOEM()">Download OEM Quote PDF</button>
          <button class="btn green" (click)="shareWhatsApp()" (click)="shareRequestViaWhatsApp()">Share on WhatsApp</button>
        </div>
          </div>
          <div class="quote-summary-card" *ngIf="selectedParts.length === 0">

          <div class="title-row">
            <span class="icon">📋</span>
            <div>
              <span class="title">Quote Summary</span>
              <p class="no-items-text">No items selected yet</p>
            </div>
          </div>


          <p class="sub-text">
            Select the parts you want to approve from the table on the left. You can preview All-OEM or All-OES totals before approving.
          </p>
        <div class="pricing-grid">

          <!-- OEM BOX -->
          <div class="price-box oem-box">
            <p class="label">ALL OEM</p>

            <h2 class="price">
              ₹{{ totalOEM | number:'1.2-2' }}
            </h2>

            <p class="coverage">
              {{ oemAvailableItems }}/{{ totalItems }} items
            </p>

            <p class="desc">Formal OEM List Pricing</p>
          </div>


          <!-- OES BOX -->
          <div class="price-box oes-box">

            <p class="label">
              {{ isOESFull ? 'All OES' : 'OES (Available Items)' }}
            </p>

            <h2 class="price">
              ₹{{ totalOES | number:'1.2-2' }}
            </h2>

            <p class="coverage">
              {{ oesAvailableItems }}/{{ totalItems }} items
            </p>

            <p class="desc">Recommended cost-effective pricing</p>

          </div>

        </div>


        <!-- Savings Box -->
        <div
          class="savings-box"
          *ngIf="isOESFull && totalOEM > totalOES"
        >
          You could save
          <b>₹{{ totalOEM - totalOES | number:'1.2-2' }}</b>
          by choosing OES for the full quote — many garages prefer OES for the same fit & lower cost.
        </div>


        <!-- Partial OES Message -->
        <div
          class="savings-box"
          *ngIf="!isOESFull && oesAvailableItems > 0"
        >
        You could save
          <b>₹{{ totalOEM - totalOES | number:'1.2-2' }}</b>
          by choosing OES <b>{{ oesAvailableItems }} out of {{ totalItems }} items</b>
          in this quote. — many garages prefer OES for the same fit & lower cost.
          OES pricing available for
          
        </div>


        <div class="button-row">
          <button
            class="btn"
            [ngClass]="{ primary1: selectedPreview === 'OES', light: selectedPreview !== 'OES' }"
            (click)="setAll('OES'); selectedPreview = 'OES'">
            Preview All OES
          </button>

          <button
            class="btn"
            [ngClass]="{ primary1: selectedPreview === 'OEM', light: selectedPreview !== 'OEM' }"
            (click)="setAll('OEM'); selectedPreview = 'OEM'">
            Preview All OEM
          </button>
        </div>


          <button class="btn approve" disabled>
            Approve Selected — (0 items) — ₹0
          </button>

          <div class="Download-links">
            <!-- <p>📄 Download Full Quote (PDF)</p> -->
            <p (click)="shareRequestViaWhatsApp()"><img src="../../../../assets/images/what'sapp.png" style="width: 6%;"> Share Full Quote (WhatsApp)</p>
          </div>

          <p class="tip">
            Tip: Use the “All OES” button above to quickly switch recommended options and preselect OES items for faster approvals.
          </p>

        </div>
        </div>
      </div>
    </div>
     <!-- Template for No Quotes Received -->
    <ng-template #noQuotesReceived >
      <div>
        <div class="empty-state">
          <div  *ngIf="isQuoteApproved(); else notApproved">
            <img src="../../../../assets/images/request-details images/requestdetailsimages.png" alt="Quote Approved" class="quote-image">
            <div  class="message">
              <strong >Quote Has Been Approved!</strong>
              <p>Check Quote Approved Section</p>
            </div>
          </div>
        </div>
        <ng-template #notApproved>
          <div class="empty-state"  *ngIf="quotationreceived.length === 0">
            <img src="../../../../assets/images/request-details images/timing.png" alt="Quote Not Created" class="quote-image" style="border-radius: 58px;">
            <div class="message">
              <strong>No quotes received yet</strong>
              <p style="margin-bottom: 0;">Autoverse team is checking availability. We'll</p>
              <p style="margin-top: 0;">notify you as soon as a quote arrives.</p>
            </div>
            <button (click)="goToRequest()">Go to Request</button>
          </div>
        </ng-template>
      </div>
    </ng-template> 
  </div>
  <!-- End Quotation Received -->

  <!-- Content for Quote Approved Tab (under quote approved tab)-->
  <div *ngIf="activeTab === 'quote-approved' && isRequestDetails">
    <div *ngIf="quotationapproved.length > 0; else noQuotesApproved" class="items">
            <div style="display: flex;justify-content: space-between;margin-top: 10px;">
      <div class="request-info"> Quote approved for {{quotationapproved.length}} items <button (click)="shareRequestViaWhatsApp()"><i>share</i>Share Approved Quote</button></div>
                  <div class="menu-container"  *ngIf="getStatus()=='✅ Quote Approved' || getStatus() === '💬 Quote Received' || getStatus() === '⏳ Requested' || getStatus() === '📦 Order Created'">
        <p class="dots" (click)="toggleEditMenu($event)">⋯</p>
      </div>
      <div *ngIf="openEditIndex"
          class="edit-menu">

        <p (click)="addMoreItems(requestDetails?.spareRequest)"><img src="../../../../assets/images/add-more.png" style="width: 14%;"> Add More Items</p>
        <p (click)="editRequest(requestDetails?.spareRequest?.id)"  *ngIf="insurance?.length>=1">📝 Edit Request Type</p>
         <!-- New Option - Add Back -->
        <p *ngIf="canEditItems()" (click)="editItem(requestDetails?.spareRequestItemList)" >✏️ Edit Request </p>
        <!-- New Option - Remove -->
        <p *ngIf="canDeleteItems() && !hasCreatedItem()"  (click)="openRequestCancelPopup()">  🗑️ Cancel Request </p>

      </div>
      </div>
       <!-- <div class="checkboxselect-approved">
        <input type="checkbox" [checked]="selectAll" (change)="ApprovedtoggleSelectAll()">
        <span style="margin-left: 21px;">Select All</span>
      </div> -->
      <div class="total-selling-price">
        <span>Total Price</span>
        <span class="total-price">₹{{ quoteApprovedSellingPrice| number:'1.2-2'}} <span class="sellingprice">₹{{quoteApprovedPrice | number:'1.2-2'}}</span> </span>
      </div>

      <!-- <hr class="divider"> -->
      <div class="quotereceived-items" *ngFor="let item of quotationapproved" [ngClass]="{'border-box': item.selected}">
           <div style="    display: flex
;">
      <div class="lines" style="display: flex;align-items: center;">        
        <div style="width: 60%;margin-left: 12px;">
            <span class="part-name" >{{item.itemName}}</span>
            <p class="item-brand">{{item.brand}}</p>
            <p class="item-brand">{{item.itemQuantity}} Unit</p>
          </div>
          </div>
          <div class="lines" style="text-align: end;">
          
            <!-- <p class="item-brand">Total MRP</p> -->
            <span class="date" style="margin-bottom: 6px; margin-top: 6px;">₹{{(item.sellingPrice * item.itemQuantity) | number:'1.2-2'}} <span class="sellingprice">₹{{(item.mrp * item.itemQuantity) | number:'1.2-2'}}</span></span>
            <div class="availability-wrapper" >
              <span class="availablity" *ngIf="!isMobile"   [ngClass]="getAvailabilityClass(transform(item.edt))">
                {{ getAvailabilityIcon(transform(item.edt))  }}  {{ transform(item.edt) }}
              </span>
              <div class="availability-subtext"  [ngClass]="getAvailabilityClass(transform(item.edt))" >  {{ getAvailabilityText(transform(item.edt)) }}</div>
            </div>
          </div>
          </div>
          <div *ngIf="isMobile" style="text-align: end;margin-top: -23px;">
            <div class="availability-wrapper" >
              <span class="availablity"  [ngClass]="getAvailabilityClass(transform(item.edt))">
                  {{ getAvailabilityIcon(transform(item.edt))  }}  {{ transform(item.edt) }}
              </span>
              <div class="availability-subtext"  [ngClass]="getAvailabilityClass(transform(item.edt))">  {{ getAvailabilityText(transform(item.edt)) }}</div>
            </div>
          </div>
      </div>  
    </div>
    <!-- Template for No Quotes Approved -->
    <ng-template #noQuotesApproved>
      <div class="empty-state">
          <div style="font-size: 60px;">📋</div>
           <div class="message">
            <strong>No approved items yet</strong>
            <p>Approve items from the Quote Received tab to see them here.</p>
          </div>
          <button (click)="approveNow()">Go to Quote Received</button>
      </div>
    </ng-template>
  </div>

  <!-- Item Info Sidebar Section -->
  <div class="overlay" [class.visible]="sidebarOpen" (click)="closeSidebar()"></div>
  <div *ngIf='itemDetails' [class.sidebar-open]="sidebarOpen" class="sidebar">
        <div class="sidebar-header" >
          <span class="sidebar-title">{{itemDetails.itemName}}</span>
          <span class="close-btn" (click)="closeSidebar()">&times;</span>
        </div>
        <div class="sidebar-content">
          <div class="sidebar-item">
            <span class="label">Brand</span>
            <span class="value" >{{ itemDetails.brand}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Quantity</span>
            <span class="value">{{itemDetails.itemQuantity}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Availability</span>
            <span class="value">{{itemDetails.edt  | date:'dd MMM yyyy, hh:mm a'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">MRP(Unit)</span>
            <span class="value">₹{{itemDetails.mrp | number:'1.2-2' }}</span>
          </div>
          <div class="sidebar-item" >
            <span class="label">MRP Total</span>
            <span class="value">₹{{itemDetails.mrp * itemDetails.itemQuantity | number:'1.2-2'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Selling Price(Unit)</span>
            <span class="value">₹{{itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100) | number:'1.2-2'}}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Total Selling Price</span>
            <span class="value">₹{{(itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100)) * itemDetails.itemQuantity | number:'1.2-2' }}</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Discount</span>
            <span class="value">{{itemDetails.sellingDiscount}} %</span>
          </div>
          <div class="sidebar-item">
            <span class="label">Part Number</span>
            <span class="value">{{itemDetails.partNumber}}</span>
          </div>
        </div>
        <button class="okay-btn" (click)="closeSidebar()">Okay, got it</button>
  </div>

  <!-- Approve Quote -->
  <div *ngIf="activeTab === 'quote-received' && !jobcardId">

    <div *ngIf="selectAll>0 || selectedItemsCount>0" class="bottom-box">
      <div class="bottom-content">
        <div>
          <div class="total-items">✅ {{selectedItemsCount}} {{ selectedItemsCount === 1 ? 'Part' : 'Parts' }} • {{selectedItemsUnit}} Units • ₹{{totalSelectedPrice | number:'1.2-2'}}</div>

        </div>
      </div>
      <button class="approve-quote-button" (click)="approveQuote()" class="approve-quote-btn">Approve Selected Quote ✨</button>
    </div>
  </div>

  
  <!-- Add to Customer Quote -->
  <div *ngIf="activeTab === 'quote-received' && jobcardId">

    <div *ngIf="selectAll>0 || selectedItemsCount>0" class="bottom-box">
      <div class="bottom-content">
        <div>
          <div class="total-items">{{selectedItemsCount}} items</div>

          <div class="total-amount">Total MRP Price ₹{{totalSelectedPrice | number:'1.2-2'}} </div>
        </div>
      </div>
      <!-- <button class="approve-quote-button" (click)="getAllRequestPopup()">Approve Quote</button> -->
      <button class="approve-quote-button" (click)="addToCustomerQuote()" class="approve-quote-btn">Add To Customer Quote</button>     
    </div>
  </div>
  
  <!-- Order Created -->
  <div *ngIf="activeTab === 'order-created'">
    <div *ngIf="!loading" style="margin-top: 17px;">

                  <div class="order-header" *ngFor="let list of filteredOrderList">
            <div class="header-row">
              <div class="req-num-mag-and-statustag">
                <div class="request-number"> 
                  <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="req-id-and-claim-type-and-id">
                    <div class="req-id">ORDER ID# {{list.orderNumber}}</div>
                    <div class="only-claim-id-type" >
                      <div class="claim-di"> Request ID# {{list.requestId}}</div>
                    </div>
                  </div>
                </div>
                <div class="header-top-row">
                  <!-- <div class="magic-quote-and-status">
                      <div class="quote-approved-container">
                        <div class="quote-approved" [ngClass]="{
                            'requested': getStatusMessage(list.statusDetails) === 'Requested',
                            'quote-received': getStatusMessage(list.statusDetails) === 'Quote Received',
                            'quote-approved': getStatusMessage(list.statusDetails) === 'Quote Approved',
                            'order-created': getStatusMessage(list.statusDetails) === 'Order Created'
                        }">{{ getStatusMessage(list.statusDetails) }}</div>
                    </div>
                    <div *ngIf="list.magicQuote==1" class="its-magic-class" > ✨ It's Magic</div>
                  </div> -->
                  <div class="magic-quote-and-status" [ngClass]="{'no-magic': magicQuote != 1}">
                    <div class="quote-approved-container">
                      <!-- <div class="quote-approved" [ngClass]="{
                          'requested': list.orderCurrentStatus === 'Delivered',
                          'quote-received': list.orderCurrentStatus === 'Confirmed',
                          'quote-approved': list.orderCurrentStatus === 'Packed',
                          'order-created': list.orderCurrentStatus==='On The Way'
                      }">
                        {{ list.orderCurrentStatus }}
                      </div> -->
  <div  *ngIf="list.packageDetails.length <= 0">
                      <div class="status requested"  *ngIf="list.orderCurrentStatus === 'Packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="list.orderCurrentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="list.orderCurrentStatus === 'Confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="list.orderCurrentStatus === 'Delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="list.orderCurrentStatus === 'created'">🆕 Created</div>
                    </div>
                       <div  *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length <= 0">
                        <div *ngFor="let delivery of list.packageDetails; let i = index">
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                       </div>
                      </div>
                    </div>

                    <div *ngIf="magicQuote == 1" class="its-magic-class">✨ It's Magic</div>
                  </div>

                </div>
              </div>
                <!-- <div *ngIf="list.magicQuote==1" ><img class="magic" src="../../../../assets/images/order-details/magic.jpg"></div> -->

        </div>

            <!-- <div class="header-row1">
                <div class="num-of-item-with-clain-id-type" >
                  <div style="display: inline; width: 90%;">
                    <div class="items-rqstd-cls">Items Requested</div>
                      <div class="no-of-items" >
                        <span *ngFor="let items of list.orderItems; index as i">
                          <span *ngIf="i!=0">,</span> {{items.partName}}</span></div>
                  </div>
                  
                <div style="width: 10%;text-align: end;">
                      <div class="total-amount-text">Total  Amount</div>
                      <div class="total-amount-price" >₹ {{list.grandTotal + list.shippingCharges}}</div>
                </div>
                </div>
            </div> -->
            <div  *ngIf ="list.packageDetails.length <= 1 && list.notPackedItems.length <= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Requested</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div  *ngIf ="list.packageDetails.length <= 0 && list.notPackedItems.length >= 0" class="delivery-content">
                <div  class="request-ids">
                  <div class="header-row1">
                    <div class="order-item">
                      <div class="items-rqstd-cls">Items Requested</div>
                      <span *ngFor="let item of list.orderItems; let idx = index" class="item-name">
                        <span *ngIf="idx != 0">,</span> {{ item.partName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="list.packageDetails.length > 1">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                              <div class="items-rqstd-cls">Items Requested</div>
                                <span *ngFor="let item of delivery.items; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                         <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                               <div class="items-rqstd-cls">Items Requested</div>
                                <span *ngFor="let item of list.notPackedItems; let idx = index" class="item-name">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
              <div *ngIf="list.packageDetails.length == 1 && list.notPackedItems.length > 0">
                <div *ngFor="let delivery of list.packageDetails; let i = index" class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">Delivery {{ i + 1 }}</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                       <div class="status requested"  *ngIf="delivery.shipmentStatus === 'packed'">📦 Packed</div>
                      <div class="status quote-received"  *ngIf="delivery.shipmentStatus === 'On The Way'">🚚 On The Way</div>
                      <div class="status quote-approved"  *ngIf="delivery.shipmentStatus === 'confirmed'">✅ Confirmed</div>
                      <div class="status order-created"  *ngIf="delivery.shipmentStatus === 'delivered'">📍 Delivered</div>
                      <div class="status ordered-created"  *ngIf="delivery.shipmentStatus === 'created'">🆕 Created</div>
                    
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of delivery.items; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.name }}
                                </span>
                              </div>
                            </div>
                          </div>
                          
                        <div class="order-status" *ngIf=" delivery.shipmentStatus === 'delivered'">
                          <div class="time-badge">
                            <div class="delived-in-time">⏰ {{ delivery.time }}</div>
                          </div>
                        </div>
                        </div>
                  </div>
                </div>
                <!-- ✅ Show Not Packed Items for each order -->
                 <div *ngIf="list.notPackedItems.length > 0">
                   <div  class="delivery-box">
                  <div class="header-and-parts">
                    <div class="delivery-header">
                      <div>
                        <div style="font-size: 15px;">To Be Delivered</div>
                        
                      </div>
                      <div>
                        <!-- <div *ngIf="delivery.shipmentStatus === 'Delivered'" class="deliverd-status-and-icon" >
                          <div class="delivered-status">Delivered</div>
                          <mat-icon class="check-circle-mat-icon delivered-status mat-icon" style="padding-top: 3px !important;">check_circle</mat-icon>
                        </div> -->
                        <div class="status quote-approved" >
                         ✅ Confirmed 
                            <!-- <mat-icon  class="check-circle-mat-icon confirmed-status">thumb_up</mat-icon> -->
                        </div>
                      </div>                      
                    </div>
                    
                        <div class="delivery-content">
                          <div  class="request-ids" style="width: 85%">
                            <div class="header-row-newest">
                              <div class="order-item-new">
                                <span *ngFor="let item of list.notPackedItems; let idx = index">
                                  <span *ngIf="idx != 0">,</span> {{ item.partName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
                </div>
                </div>

              </div>
            <div class="header-row2">
              <div class="request-date">Placed on: {{list.createdAt | date:'dd MMM yyyy, hh:mm a'}}</div>
              <a class="view-btn" (click)="loadorderdetails(list.orderKey)" >
                <mat-icon style="color: white; margin-right: 0px;">keyboard_arrow_right</mat-icon>
                <div class="view">View Details</div>
              </a>
            </div>
          </div>
      </div>
  </div>

</div>

</div>
<div #dynamicContainer></div>

<!-- Edit Item -->
<div class="overlay1" [class.visible]="isPopupOpenEdit" (click)="closePopupEdit()"></div>
<div *ngIf="isPopupOpenEdit" [ngClass]="isMobile ? 'bottom-sheetMobile' : 'bottom-sheet'">
  <header class="back-button">
    <h3 class="header-name">{{ itemQuote.itemName }}</h3>
    <mat-icon (click)="closePopupEdit()" class="close-pop-up">close</mat-icon>
  </header>
  <div class="bottom-sheet-content">
    <form [formGroup]="unitPrice" >
    <div class="unit-price">
      <mat-form-field appearance="outline" class="full-width" class="edit-labour-details">
        <mat-label>Unit Price</mat-label>
        <input
          matInput
          formControlName="unitprice"                            
          [(ngModel)]="itemQuote.mrp"
          placeholder="Enter Unit Price*"
          required
          name="Unit Price"
          pattern="^[0-9]*$"
        />
        </mat-form-field>
    </div>
  </form>
    <button (click)="save()">Save Quote</button>
  </div>
</div>
<!-- End Edit Item -->


<!-- Popup content -->
<div *ngIf="isQuotationPopup" class="add-items-to-quotation popup">
  <div class="popup-content">
    <mat-icon (click)="closeQuotationPopup()" style="float: right; cursor: pointer;">close</mat-icon>
    <h3>Quotation Confirmation</h3>
        
    <p class="order-label">Customer Quotation Already Exists.</p>
    
    <p class="">Would you like to edit the customer quotation?</p>

    <button class="quote-yes" (click)="editQuotationItems()">Yes</button>
    <button class="quote-no" (click)="closeQuotationPopup()">No</button>
  </div>
</div>


<div #createQuotationContainer></div>

<div #intstantorder></div>

 <div class="overlay-insurance" [class.visible]="isInsurance" (click)="goBackList()" *ngIf="isInsurance && !isMobile"></div>

<div class="sidebar-container" *ngIf="isInsurance">
  <div class="create-req">
    <div ><i (click)="goBackList()" >arrow_back</i>
      Update Request Type
    </div>
    <div class="info" (click)="showPopup()">
      ?
    </div>
  </div>
  
  <div class="overflow">
  <h3 class="choose">Choose Request Type</h3>

  <div class="options">
    <div class="card" [ngClass]="{active: selectedType === 'insurance'}"
         (click)="selectType('insurance')">
      <div class="icon">🛡️</div>
      <div>
        <h4>Insurance</h4>
        <p>For insurance claims with insurer billing</p>
      </div>
    </div>

    <div class="card" [ngClass]="{active: selectedType === 'non-insurance'}"
         (click)="selectType('non-insurance')">
      <div class="icon">🧾</div>
      <div>
        <h4>Non-Insurance</h4>
        <p>For retail/regular jobs</p>
      </div>
    </div>
  </div>

   <div class="insurance-section" *ngIf="selectedType === 'insurance' && insurance.length>1">
  <h4 class="subtitle">Select Insurance Company</h4>
  <input
    type="text"
    class="search-box"
    placeholder="Search insurer (e.g., ICICI, HDFC)"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchChange()"
  />

  <div class="company-grid">
    <div
      class="company-card"
      *ngFor="let company of filteredList"
      (click)="selectCompany(company)"
      [ngClass]="{ selected: selectedCompany === company.insuranceGarageKey }"
    >
      <!-- <div class="circle"></div> -->
      <p>{{ company.insuranceGarageName }}</p>
    </div>
  </div>
</div>

</div>

<div class="error-div">
      <p class="error" *ngIf="showError">
    Please choose Insurance or Non-Insurance.
  </p>     
   <p class="error" *ngIf="showError1">
    Please select an insurance company.
  </p>
  <div class="actions" >
    <button class="primary-btn"
        [class.active]="isContinueActive"
        (click)="updateInsurance()" style="width: 97%;">
      Update
    </button>

  </div>
  </div>
</div>
<div class="popup-overlay" *ngIf="showPopupinfo">
  <div class="popup-box">
    <h3>Which option to choose?</h3>
    <p>
      <strong>Insurance:</strong><br>
      If work is under insurance claim. We'll bill the insurer.
    </p>
    <p>
      <strong>Non-Insurance:</strong><br>
      For regular/retail jobs. We'll bill the garage.
    </p>
    <button (click)="closePopup()">Got it</button>
  </div>
</div>
  <div class="popup-overlay" *ngIf="approved">
  <div class="popup-box" style="    text-align: center;">
    <img src="{{successIcon}}" >
    <h3>Quote-Approved!</h3>
    <p class="order-label" ><span class="order-id" >{{approveData.id}}</span></p>
    <!-- <p class="date"><span>{{data.approvedAt  | date:'dd MMM yyyy'}}</span></p> -->
    <p class="date"><span>{{approveData.approvedAt | date:'dd MMM yyyy, hh:mm a': 'GMT+1060' }}</span></p>

    <p class="thank you">Thank you for aproving the quote</p>
    <button class="goto-order" (click)="goToQuoteApproved()">View Approved Quote</button>
    <!-- <button class="goto-order" (click)="goToQuoteApproved()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length > 0 || quotationapproved.length > 0)">View Approved Quote</button> -->
    <!-- <button type="button" class="QuoteBtn"  (click)="openSidebarQuote()" *ngIf="activeTab === 'quote-received' && (quotationreceived.length > 0 || quotationapproved.length > 0)" >Create Customer Quote</button> -->
  </div>
</div>

<!-- ===========================xle oes recomondation================== -->
<!-- OVERLAY -->
<div class="avx-multiple-oes-sidebar-overlay" *ngIf="showAvxOesRecommendationSidebar" (click)="showAvxOesRecommendationSidebar = false"></div>
  <!-- SIDEBAR -->
<div class="avx-multiple-oes-sidebar" *ngIf="showAvxOesRecommendationSidebar">
  <div class="avx-multiple-oes-sidebar-header">
    <div class="avx-multiple-oes-sidebar-header-left">
      <div class="avx-multiple-oes-sidebar-icon">🛠️</div>
      <div>
        <div class="head-wth-cls">
          <h2>Compare More OES Options</h2>
          <button class="avx-multiple-oes-sidebar-close"
            (click)="showAvxOesRecommendationSidebar = false">
            ✕
          </button>
        </div>
        <p>Choose the brand that fits your budget and delivery preference.</p>
      </div>
    </div>
    <div class="avx-multiple-oes-sidebar-info-strip">
      <span>
        Showing for:
        <b>{{ selectedSidebarPart?.title }}</b>
      </span>
      <span class="oem-price" *ngIf="selectedSidebarPart?.oem">
        OEM ₹{{ selectedSidebarPart?.oem?.sellingPrice | number:'1.2-2' }}
      </span>
    </div>
    <div class="avx-multiple-oes-sidebar-saving-strip">
      ⚡ Lower cost alternatives available
    </div>
  </div>

  <!-- MULTIPLE OES -->
  <div class="avx-multiple-oes-sidebar-content"
    *ngFor="let oes of filteredSidebarOes; let i = index">
    <div class="avx-multiple-oes-card"
      [class.active-card]="selectedCardIndex === i"
      (click)="selectSidebarOes(oes, i)">
      <div class="avx-multiple-oes-card-top">
        <div>
          <h3>{{ oes.brand }}</h3>
          <p>Qty: {{ selectedSidebarPart?.qty }}</p>
        </div>
        <div class="avx-multiple-oes-card-right">
          <span class="available" [ngClass]="getAvailabilityClass(transform(oes.edt))">
            {{ getAvailabilityIcon(transform(oes.edt)) }}
            {{ transform(oes.edt) }}
          </span>
          <div class="availability-subtext" [ngClass]="getAvailabilityClass(transform(oes.edt))">{{ getAvailabilityText(transform(oes.edt)) }}</div>
          <button class="selected-btn" *ngIf="selectedCardIndex === i"> ✓ Selected</button>
        </div>
      </div>
      <div class="avx-multiple-oes-price-section">
        <div class="price-row">
          <span class="main-price">
            ₹{{ oes.sellingPrice | number:'1.2-2' }}
          </span>
          <span class="strike-price">
            ₹{{ oes.mrp | number:'1.2-2' }}
          </span>
        </div>
      </div>
      <div class="avx-multiple-oes-saving-box"
        *ngIf="selectedSidebarPart?.oem  && selectedSidebarPart?.oem?.sellingPrice > oes.sellingPrice"> 🏆 You save ₹{{ (selectedSidebarPart?.oem?.sellingPrice - oes.sellingPrice) | number:'1.2-2' }} vs OEM
      </div>
    </div>
  </div>
  <div class="avx-multiple-oes-footer-btn">
    <button (click)="confirmOesSelection()"   [disabled]="selectedCardIndex === -1" >Confirm Selection</button>
    <div class="avx-multiple-oes-footer-btn-sprt-txt">You can change your selection anytime before approval</div>
  </div>
</div>


<!-- Cancel Full Request Popup -->
<div class="av-request-cancel-overlay" *ngIf="showRequestCancelPopup">
  <div class="av-request-cancel-modal">
    <div
      class="av-request-cancel-close-icon"
      (click)="closeRequestCancelPopup()">
      ✕
    </div>
    <div class="av-request-cancel-icon-wrap">🗑️</div>
    <h3 class="av-request-cancel-title">
      Cancel this request?
    </h3>
    <p class="av-request-cancel-subtitle">
      Are you sure you want to cancel this request?
      This action cannot be undone.
    </p>

    <div class="av-request-cancel-warning">
      <span>⚠️</span>
      <p>
        All items in this request will be permanently removed
        and cannot be recovered.
      </p>
    </div>

    <button
      class="av-request-cancel-confirm-btn"
      (click)="confirmCancelRequest()">
      Yes, Cancel
    </button>

    <button
      class="av-request-cancel-close-btn"
      (click)="closeRequestCancelPopup()">
      Cancel
    </button>

  </div>
</div>

<!-- Success Popup: Request Cancelled -->
<div class="ss-request-success-overlay" *ngIf="showRequestCancelSuccessPopup">
  <div class="ss-request-success-card">

    <!-- close icon -->
    <button class="ss-request-success-close" (click)="closeRequestCancelSuccessPopup()" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6l12 12" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- drag handle (mobile sheet style) -->
    <div class="ss-request-success-handle"></div>

    <!-- success icon -->
    <div class="ss-request-success-icon">
      ✅
    </div>

    <!-- title & subtitle -->
    <h2 class="ss-request-success-title">Request Cancelled</h2>
    <p class="ss-request-success-subtitle">Your request has been successfully canceled.</p>

    <!-- request info box -->
    <div class="ss-request-success-infobox">
      <span class="ss-request-success-infobox-icon">📋</span>
      <div class="ss-request-success-infobox-text">
        <span class="ss-request-success-infobox-id">Request #{{ requestDetails?.spareRequest?.id }}</span>
        <span class="ss-request-success-infobox-desc">Successfully removed from the system.</span>
      </div>
    </div>

    <!-- action button -->
    <button class="ss-request-success-btn" (click)="closeRequestCancelSuccessPopup()">
      Okay, Got It
    </button>

  </div>
</div>